<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="store/product-group/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { ProductGroup } from '@/modules/store/data/product-group/create'
	import { ProductGroupService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return ProductGroup;
			},

			service()
			{
				return new ProductGroupService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>